var idCompany = 1;
var user = "";
var password = "";
var token = "";

const getIdCompany = () => idCompany;
const setIdCompany = (value) => (idCompany = value);
const getToken = () => token;
const setToken = (value) => (token = value);
const setUserGlobal = (value) => (user = value);
const setPasswordGlobal = (value) => (password = value);

export {
  getIdCompany,
  setIdCompany,
  setToken,
  getToken,
  user,
  password,
  token,
  setUserGlobal,
  setPasswordGlobal,
};
